import { Component, OnInit, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'kt-soft-progress-bar-lilac',
  template: `
    <span class="font-fix">
      {{ prefix }} {{ absoluteValueCalculated | number: '1.0-0' }} {{ suffix }}
      ( {{ percentValueCalculated | number: '1.2-2' }} % )
    </span>
    <mat-progress-bar
      class="lilac"
      [mode]="_mode"
      [value]="percentValueBar">
    </mat-progress-bar>
  `,
  styleUrls: ['./soft-progress-bar.component.scss']
})
export class SoftProgressBarLilacComponent implements OnInit, OnDestroy {
  @Input() public percentValue: number = 0;
  @Input() public absoluteValue: number = 0;

  @Input() public prefix: string = "";
  @Input() public suffix: string = "";
  @Input() public _class: string = "lilac";
  @Input() public _mode: string = "determinate";

  public percentValueCalculated: number = 0;
  public absoluteValueCalculated: number = 0;
  public percentValueBar: number = 0;

  private animationTimer: any;
  private readonly easing: number = 0.1; // suavidade da animação

  ngOnInit(): void {
    this.animationTimer = setInterval(() => {
      this.updateSmoothProgress();
    }, 16); // ~60 FPS
  }

  ngOnDestroy(): void {
    if (this.animationTimer) {
      clearInterval(this.animationTimer);
    }
  }

  private updateSmoothProgress(): void {
    // Percentual
    const deltaPercent = this.percentValue - this.percentValueCalculated;
    if (Math.abs(deltaPercent) > 0.05) {
      this.percentValueCalculated += deltaPercent * this.easing;
    } else {
      this.percentValueCalculated = this.percentValue;
    }

    // Absoluto
    const deltaAbs = this.absoluteValue - this.absoluteValueCalculated;
    if (Math.abs(deltaAbs) > 0.5) {
      this.absoluteValueCalculated += deltaAbs * this.easing;
    } else {
      this.absoluteValueCalculated = this.absoluteValue;
    }

    // Atualiza barra visual arredondando
    this.percentValueBar = Math.round(this.percentValueCalculated);
  }
}

@Component({
  selector: 'kt-soft-progress-bar-red',
  template: `
    <span class="font-fix">
      {{ prefix }} {{ absoluteValueCalculated | number: '1.0-0' }} {{ suffix }}
      ( {{ percentValueCalculated | number: '1.2-2' }} % )
    </span>
    <mat-progress-bar class="red" mode="determinate" [value]="percentValueBar"></mat-progress-bar>
  `,
  styleUrls: ['./soft-progress-bar.component.scss']
})
export class SoftProgressBarRedComponent extends SoftProgressBarLilacComponent {}

@Component({
  selector: 'kt-soft-progress-bar-green',
  template: `
    <span class="font-fix">
      {{ prefix }} {{ absoluteValueCalculated | number: '1.0-0' }} {{ suffix }}
      ( {{ percentValueCalculated | number: '1.2-2' }} % )
    </span>
    <mat-progress-bar class="green" mode="determinate" [value]="percentValueBar"></mat-progress-bar>
  `,
  styleUrls: ['./soft-progress-bar.component.scss']
})
export class SoftProgressBarGreenComponent extends SoftProgressBarLilacComponent {}

@Component({
  selector: 'kt-soft-progress-bar-blue',
  template: `
    <span class="font-fix">
      {{ prefix }} {{ absoluteValueCalculated | number: '1.0-0' }} {{ suffix }}
      ( {{ percentValueCalculated | number: '1.2-2' }} % )
    </span>
    <mat-progress-bar class="blue" mode="determinate" [value]="percentValueBar"></mat-progress-bar>
  `,
  styleUrls: ['./soft-progress-bar.component.scss']
})
export class SoftProgressBarBlueComponent extends SoftProgressBarLilacComponent {}
